import React from 'react';

export interface TextProps {
	align?: 'left' | 'right' | 'center';
	bold?: boolean;
	capitalize?: boolean;
	color?: string;
	italic? : boolean;
	lineHeight?: number | string;
	lowercase?: boolean;
	size?: number;
	underline?: boolean;
	uppercase?: boolean;
}

export const styleFromTextProps = (props: TextProps) => {
	const style: React.CSSProperties = {
		color: props.color,
		fontSize: props.size,
		lineHeight: props.lineHeight,
		textAlign: props.align,
	};

	if (props.uppercase) {
		style.textTransform = 'uppercase';
	} else if (props.lowercase) {
		style.textTransform = 'lowercase';
	} else if (props.capitalize) {
		style.textTransform = 'capitalize';
	}

	if (props.underline) {
		style.textDecoration = 'underline';
	}

	if (props.bold) {
		style.fontWeight = 'bold';
	}

	if (props.italic) {
		style.fontStyle = 'italic';
	}

	return style;
};

export default (props: React.PropsWithChildren<TextProps & { style?: React.CSSProperties; }>) => {
	return (
		<span style={{ ...styleFromTextProps(props), ...props.style }}>
			{props.children}
		</span>
	);
};
